import React, { Fragment } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Home } from "react-feather";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const Breadcrumbs: React.FC<any> = (props) => {
  return (
    <Fragment>
      <Container fluid={true}>
        <div className="page-title">
          <Row>
            <Col xs="6">
              <h3>
                <FormattedMessage id={props.title} />
              </h3>
            </Col>
            <Col xs="6">
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to={`${process.env.PUBLIC_URL}/`}>
                    <Home />
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <FormattedMessage id={props.parent} />
                </BreadcrumbItem>
                <BreadcrumbItem active>
                  <FormattedMessage id={props.title} />
                </BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;
